let readyPromise: Promise<Office.AddinCommands.EventCompletedOptions | void> | null = null;

export function officeReady(): Promise<Office.AddinCommands.EventCompletedOptions | void> {
  if (readyPromise) return readyPromise;
  readyPromise = new Promise((resolve) => {
    Office.onReady((info) => {
      resolve(info as unknown as Office.AddinCommands.EventCompletedOptions);
    });
  });
  return readyPromise;
}
